import { flexRender, type Table as TanStackTable } from "@tanstack/react-table";

import Loading from "../../../../../components/Loading";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../components/ui/table";
import { getColumnMeta, getColumnSortAria } from "../utils";
import { type AdministrativeAreaType } from "../../../types";

interface AdministrativeAreaTypesDataTableProps {
  emptyMessage: string;
  isLoading: boolean;
  table: TanStackTable<AdministrativeAreaType>;
}

const AdministrativeAreaTypesDataTable = ({
  emptyMessage,
  isLoading,
  table,
}: AdministrativeAreaTypesDataTableProps) => {
  const rows = table.getRowModel().rows;
  const columnCount = table.getVisibleLeafColumns().length;

  return (
    <Table>
      <TableHeader>
        {table.getHeaderGroups().map(headerGroup => (
          <TableRow key={headerGroup.id}>
            {headerGroup.headers.map(header => (
              <TableHead
                key={header.id}
                className={getColumnMeta(header.column.columnDef)?.headerClassName}
                aria-sort={getColumnSortAria(header.column)}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(header.column.columnDef.header, header.getContext())}
              </TableHead>
            ))}
          </TableRow>
        ))}
      </TableHeader>
      <TableBody>
        {isLoading ? (
          <TableRow>
            <TableCell colSpan={columnCount}>
              <Loading isVisible small />
            </TableCell>
          </TableRow>
        ) : null}
        {!isLoading && rows.length === 0 ? (
          <TableRow>
            <TableCell colSpan={columnCount} className="h-24 text-center text-muted-foreground">
              {emptyMessage}
            </TableCell>
          </TableRow>
        ) : null}
        {!isLoading && rows.length
          ? rows.map(row => (
              <TableRow key={row.id}>
                {row.getVisibleCells().map(cell => (
                  <TableCell
                    key={cell.id}
                    className={getColumnMeta(cell.column.columnDef)?.cellClassName}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableCell>
                ))}
              </TableRow>
            ))
          : null}
      </TableBody>
    </Table>
  );
};

export { AdministrativeAreaTypesDataTable };
